module.exports = require("./analyticstracker.min.js");
